import { Fragment } from "react"
import { type Maybe } from "@oefr/utils/types"

type FormatSplitFullAddressProps = {
    splitFullAddress: Maybe<Array<Maybe<string>>>
}

export function FormatSplitFullAddress({ splitFullAddress }: FormatSplitFullAddressProps) {
    return splitFullAddress?.filter(Boolean).map((addressLine, index) => (
        <Fragment key={addressLine}>
            {addressLine}
            {index !== splitFullAddress.length - 1 && <br />}
        </Fragment>
    ))
}
